/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'object',
      properties: {
        unit: {
          type: 'string',
          enum: ['PERCENTAGE'],
        },
        ghgEmissionsOffsetScope1: {
          type: 'number',
          maximum: 100,
        },
        ghgEmissionsOffsetScope2: {
          type: 'number',
          maximum: 100,
        },
        ghgEmissionsOffsetScope3: {
          type: 'number',
          maximum: 100,
        },
      },
      required: ['ghgEmissionsOffsetScope1', 'unit', 'ghgEmissionsOffsetScope3', 'ghgEmissionsOffsetScope2'],
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    ghg_emissions_offset_scope: valueSchema,
  },
}
